import { Capacitor } from "@capacitor/core";
import * as Sentry from "@sentry/capacitor";

export class SystemLogService {
  private static logEnabled: boolean = false;
  private initialized = false;

  public isInitialized(): boolean {
    return this.initialized;
  }

  static enableLogging() {
    this.logEnabled = true;
  }

  static logMessage(message: string | null) {
    if (!this.logEnabled) {
      return;
    }
    if (!message)
      return;
    console.log('WILLIEB->debug->', message);
  }



  static logError(errorObject: unknown, statusText: string = 'error', title: string = 'error') {
    if (!errorObject) return;

    const isString = (val: any): val is string => typeof val === 'string' || val instanceof String;

    if (isString(errorObject)) {
      Sentry.captureMessage(errorObject, {
        level: 'error',
        tags: { statusText, title }
      });
    } else if (errorObject instanceof Error) {
      Sentry.captureException(errorObject, {
        tags: { statusText, title }
      });
    } else if (typeof errorObject === 'object') {
      const context: any = errorObject;
      const message =
        context.message ||
        context.error?.message ||
        context.statusText ||
        'Unknown error object';

      Sentry.captureMessage(message, {
        level: 'error',
        tags: { statusText, title },
        extra: { error: context }
      });
    } else {
      Sentry.captureMessage(`Non-object error: ${JSON.stringify(errorObject)}`, {
        level: 'error',
        tags: { statusText, title }
      });
    }
  }
}


